<template>
  <div class="container">
    <van-skeleton title :row="3" />
  </div>
</template>

<script>
import { Skeleton } from "vant";
export default {
  name: "SkeletonNormal",
  components: {
    "van-skeleton": Skeleton,
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.container {
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px 0;
}
</style>